var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 12.25V8.75C14 7.82174 14.3687 6.9315 15.0251 6.27513C15.6815 5.61875 16.5717 5.25 17.5 5.25H24.5C25.4283 5.25 26.3185 5.61875 26.9749 6.27513C27.6313 6.9315 28 7.82174 28 8.75V12.25M21 21V21.0175M5.25 15.75C5.25 14.8217 5.61875 13.9315 6.27513 13.2751C6.9315 12.6187 7.82174 12.25 8.75 12.25H33.25C34.1783 12.25 35.0685 12.6187 35.7249 13.2751C36.3813 13.9315 36.75 14.8217 36.75 15.75V31.5C36.75 32.4283 36.3813 33.3185 35.7249 33.9749C35.0685 34.6313 34.1783 35 33.25 35H8.75C7.82174 35 6.9315 34.6313 6.27513 33.9749C5.61875 33.3185 5.25 32.4283 5.25 31.5V15.75Z",
    stroke: "#367FFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 22.75C10.1353 25.2117 15.5296 26.494 21 26.494C26.4704 26.494 31.8647 25.2117 36.75 22.75",
    stroke: "#367FFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBriefcase);
export default __webpack_public_path__ + "static/media/icon-briefcase.419177a302d3b37c9c15718567456b04.svg";
export { ForwardRef as ReactComponent };